<template>
    <v-row align="center"
           justify="center">
        <v-col cols="12"
               md="6">
            <v-form @submit.prevent="submit"
                    ref="loginForm">
                <v-card :elevation="12">
                    <v-toolbar dark
                               flat
                               color="black">
                        <v-toolbar-title>
                            Machine Instruction Manuals
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-text-field v-model="form.serial_number"
                                      label="Machine Serial Number"
                                      prepend-icon="mdi-file-pdf"
                                      :error="form.errors.has('serial_number')"
                                      :error-messages="form.errors.get('serial_number')"
                                      required>
                        </v-text-field>
                        <v-text-field v-model="form.access_code"
                                      label="Access Code"
                                      type="password"
                                      prepend-icon="mdi-lock"
                                      :error="form.errors.has('access_code')"
                                      :error-messages="form.errors.get('access_code')"
                                      required>
                        </v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn type="submit"
                               dark
                               color="black">
                            <v-icon class="mr-1">
                                mdi-file-search
                            </v-icon>
                            Search
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-col>
    </v-row>
</template>
<script>
    import {Form} from 'vform';

    export default {
        data() {
            return {
                form: new Form({
                    password: '',
                    access_code: '',
                })
            }
        },
        methods: {
            submit() {
                const url = '/api/combi/manuals/search';
                this.form.post(url)
                    .then(response => {
                        const data = response.data;
                        if (navigator.appName.indexOf('MSIE')) {
                            location.href = data.share_url;
                        } else {
                            let link = document.createElement('a');
                            link.href = data.share_url;
                            link.target = '_blank';
                            link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
                        }
                    });
            }
        }
    }
</script>
